"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredAssets = void 0;
const getFilteredAssets = (tokens, groupTokenConfigs) => {
    const toReturn = {};
    const groupTokenConfigsSet = new Set(groupTokenConfigs);
    // console.log("Global tokens = ", tokens);
    // console.log("Group token configs = ", groupTokenConfigs);
    // console.log("Group token configs as set = ",groupTokenConfigsSet);
    tokens.forEach((tl) => {
        // console.log(tl.currency)
        // console.log(groupTokenConfigsSet.has(tl.currency))
        if (groupTokenConfigsSet.has(tl.currency)) {
            toReturn[tl.currency] = tl;
        }
    });
    return toReturn;
};
exports.getFilteredAssets = getFilteredAssets;
//# sourceMappingURL=walletApplicationWrapperHelper.js.map